<template>
  <div class="legend_container" @click="isLegendVisible = !isLegendVisible">
    <div style="position: relative" v-if="true">
      <div class="select_box">
        <div style="display: flex; align-self: flex-end">
          <div class="select_box_text">タイプ一覧</div>
          <i
            class="material-icons"
            style="
              align-self: center;
              color: #8a8d93;
              font-size: 20px;
              margin-left: 5px;
            "
          >
            &#xe241;
          </i>
        </div>
      </div>
      <div
        style="
          position: absolute;
          overflow-y: auto;
          right: 0px;
          top: 35px;
          width: 350px;
          background: #ffffff;
        "
        v-if="isLegendVisible"
      >
        <div
          style="
            margin: 5px;
            border: 1px solid rgba(52, 58, 63, 0.1);
            box-shadow: 0px 2px 10px rgba(58, 53, 65, 0.1);
            padding: 10px;
            border-radius: 12px;
          "
        >
          <div style="display: flex; align-items: center">
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #237e9d;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">単純リユース</div>
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #6bdbd1;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">クリエイティブ</div>
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #6558d3;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">リサイクル</div>
          </div>
          <div style="display: flex; align-items: center">
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #4db8ad;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">ケミカルリサイクル</div>
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #4db280;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">マテリアルリサイクル</div>
          </div>
          <div style="display: flex; align-items: center">
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #f8735d;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">サーマルリサイクル</div>
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #cd87dc;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">焼却後リサイクル</div>
          </div>
          <div style="display: flex; align-items: center">
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #f0a6ce;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">単純焼却</div>
            <div>
              <i
                class="material-icons"
                style="
                  align-self: center;
                  color: #f4b852;
                  font-size: 16px;
                  margin-left: 5px;
                "
              >
                &#xe3fa;
              </i>
            </div>
            <div class="select_box_text">埋立</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecycleTypeChartLegend',
  data() {
  return {
    isLegendVisible: false,
  }
  },
}
</script>

<style scoped>
.select_box {
  /* box-sizing: border-box; */

  /* Auto layout */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 6px 16px;

  height: 36px;
  left: 1279px;
  top: 12px;

  /* Light/Background/Paper */

  background: #ffffff;
  /* Light/Other/Divider */

  /* border: 1px solid rgba(52, 58, 63, 0.1); */
  /* border-radius: 8px; */
}

.select_box_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 150% */

  letter-spacing: 0.15px;
  padding: 5px 0px;

  /* Light/Text/Primary */

  color: #697077;
  text-align: center;
}

.select_box_text_selected {
  background: #d0dcf2;
  border-radius: 8px;
  color: #0e5df0;
}

.legend_container {
  display: flex;
}

.legend_container:hover {
  cursor: pointer;
}
</style>
